if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'lorraine-lee-wishlist';
      this.button = this.querySelector('.wishlist-toggle');
    }

    connectedCallback() {
      if (!this.button) return;
      this.productId = this.dataset.productId;
      this.render();
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    getWishlist() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    setWishlist(list) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(list));
      } catch (error) {
        // Ignore storage errors (e.g. private browsing quota).
      }
    }

    isSaved() {
      return this.getWishlist().includes(this.productId);
    }

    onClick() {
      const list = this.getWishlist();
      const index = list.indexOf(this.productId);

      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(this.productId);
      }

      this.setWishlist(list);
      this.render();
    }

    render() {
      const saved = this.isSaved();
      this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      this.button.setAttribute(
        'aria-label',
        saved ? this.button.dataset.removeLabel : this.button.dataset.addLabel
      );
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
